/***
 * Get the relative path from a file to the root of the site.
 */
export function getPathToRoot(path: string) {
    const hasLeadingSlash = path.startsWith("/");
    const levels = Math.max(0, path.split("/").length - (hasLeadingSlash ? 2 : 1)); // Remove the leading / and the file name
    return "./" + "../".repeat(levels);
}
